module.exports = require("core-js/modules/es.set.js");